<!--<div *ngIf="ForgetPasswordStep === 0">

  <div class="container-scroller bg-bluebar">
    <div class="center-div">

      <div class="row">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="card card-width box-shadow3">
            <div class="card-header background-white padding-bottom">

              
              <div class="row">
                <a class="user-image-circle-65px">
                  <img src="RNCloud_logo.png"
                       height="30px" class="margin-left-13px">
                </a>
              </div>
              <h4 class="title font-size-16px margin-top-27" id="myModalLabel">Recover password</h4>



            </div>



            <div class="card-body background-white">

              <div class="col-md-12 col-xs-12 login_control">




                <div class="control">
                  <div class="label font-size-11px">Email ID (User Name)<span>*</span></div>
                  <div class="input-group">
                    <label class="col-12">

                    

                      <input type="text" class="form-control border-bottom-tbl"
                             name="CurrentForgotPasswordRequest.UserName"
                             id="CurrentForgotPasswordRequest.UserName" required
                             placeholder="Email ID (User Name)"
                             [(ngModel)]="CurrentForgotPasswordRequest.UserName" maxlength="50" #UserName="ngModel">
                      <small class="form-text text-danger"
                             *ngIf="(!UserName.valid && (UserName.dirty || UserName.touched))">(Required)</small>

                    </label>
                  </div>
                </div>
                <div class="control signin-control">
                  
                </div>


              </div>


            </div>

            <div class="card-footer text-align-center">

             
              <a (click)="onLogin()" class="btn button-Schedule  actions-btn-prime font-size-13px actions-btn-prime3 margin-right-9px">Back</a>
              <button type="submit" [disabled]="!f.valid" class="btn btn-primary nav-link-hand  font-size-13px" *ngIf='!isRequesting'>Submit</button>
            </div>



          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div *ngIf="ForgetPasswordStep === 1">

  <div class="container-scroller bg-bluebar">
    <div class="center-div">

      <div class="row">
        <form class="form" novalidate="" #f="ngForm">
          <div class="card card-width box-shadow3">
            <div class="card-header background-white padding-bottom">

             
              <div class="row">
                <a class="user-image-circle-65px">
                  <img src="../../../../../../wwwroot/healins-assets/images/RNCloud_logo.png"
                       height="30px" class="margin-left-13px">
                </a>
              </div>
              <h4 class="title font-size-16px margin-top-27" id="myModalLabel">Recover password</h4>



            </div>



            <div class="card-body background-white">

              <div class="col-md-12 col-xs-12 login_control">




                <div class="control">
                  <div class="label font-size-11px">Transaction Code<span>*</span></div>
                  <div class="input-group">
                    <label class="col-12">

                    

                      <input type="text" class="form-control border-bottom-tbl" name="CurrentResendOTPRequest.OTPActivationCode"
                             id="CurrentResendOTPRequest.OTPActivationCode" required placeholder="Enter OTP"
                             [(ngModel)]="CurrentResendOTPRequest.OTPActivationCode" minlength="6" maxlength="6" pattern="[0-9]{6}" #ActivationCode="ngModel">
                      <small class="form-text text-danger"
                             *ngIf="(!ActivationCode.valid && (ActivationCode.dirty || ActivationCode.touched))">(Provide Valid OTP)</small>

                    </label>
                  </div>
                </div>
                <div class="control signin-control">
                  
                </div>


              </div>


            </div>

            <div class="card-footer text-align-center">
              <button type="button" class="btn button-Schedule  actions-btn-prime font-size-13px actions-btn-prime3 margin-right-9px" (click)="onResendOTP()" *ngIf='!isRequesting'>Resend</button>
              <button type="button" [disabled]="!of.valid" class="btn btn-primary nav-link-hand font-size-13px"
                      (click)="onOTPSubmit()"
                      *ngIf='!isRequesting'>
                Confirm 
              </button>

            </div>



          </div>
        </form>
      </div>
    </div>
  </div>
</div>-->
<div >

  <div class="container-scroller bg-bluebar">
    <div class="center-div sign-left-sm-69px">

      <div class="row">
        <form class="form" novalidate="" (ngSubmit)="onChangePassword()"  #f="ngForm">
          <div class="card card-width box-shadow3 border-card-signin">
            <div class="card-header background-white padding-bottom">

             
              <div class="row">
                <a class="user-image-circle-65px">
                  <img src="garbhagudilogo(small).png"
                       width="33px" height="40px" class="margin-left-13px">
                </a>
              </div>
              <h4 class="title font-size-16px margin-top-27" id="myModalLabel">Change Password</h4>



            </div>



            <div class="card-body background-white padding-left-5px padding-right-5px">

              <div class="col-md-12 col-xs-12 login_control padding-left-5px padding-right-5px">


                <div class="control">
                  <label class="margin-bottom">Hello </label>
                  <label class="margin-bottom-0px margin-left-5px font-weight-bold color-green " *ngIf="UserName2">{{UserName2}}</label>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 padding-right-5px">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Old Password</label>
                      </div>

                      <div class="col-md-6">
                        <input type="password" class="form-control  border-bottom-tbl"
                               name="CurrentChangePasswordRequest.OldPassword"
                               id="CurrentChangePasswordRequest.OldPassword" pattern="^[\sa-zA-Z0-9,._\-?,$@!%*?&]*$"
                               placeholder="Enter OldPassword" [(ngModel)]="CurrentChangePasswordRequest.OldPassword" required #OldPassword="ngModel" minlength="8" maxlength="15">

                        <small class="form-text text-danger"
                               *ngIf="(!OldPassword.valid && (OldPassword.dirty || OldPassword.touched)  && OldPassword.errors.minlength && !isRequesting)">(Mininum 8 Chars)</small>

                      </div>
                    </div>
                  </div>
                </div>
                <!--<div class="control">
                  <div class="label font-size-11px"></div>
                  <div class="input-group">
                    <div class="row margin-left-0px margin-right-0px">
                      <label class="col-4">
                        Old Password
                      </label>
                      <label class="col-8">
                        <input type="password" class="form-control  border-bottom-tbl"
                               name="CurrentChangePasswordRequest.OldPassword"
                               id="CurrentChangePasswordRequest.OldPassword" pattern="^[\sa-zA-Z0-9,._\-?,$@!%*?&]*$"
                               placeholder="Enter OldPassword" [(ngModel)]="CurrentChangePasswordRequest.OldPassword" required #OldPassword="ngModel" minlength="8" maxlength="15">

                        <small class="form-text text-danger"
                               *ngIf="(!OldPassword.valid && (OldPassword.dirty || OldPassword.touched)  && OldPassword.errors.minlength && !isRequesting)">(Mininum 8 Chars)</small>
                      </label>
                    </div>
                  </div>
                </div>-->
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 padding-right-5px">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-5px">New Password</label>
                      </div>

                      <div class="col-md-6">
                        <input type="password" class="form-control  border-bottom-tbl"
                               name="CurrentChangePasswordRequest.NewPassword"
                               id="CurrentChangePasswordRequest.NewPassword" pattern="^[\sa-zA-Z0-9,._\-?,$@!%*?&]*$"
                               placeholder="Enter NewPassword" [(ngModel)]="CurrentChangePasswordRequest.NewPassword" required #NewPassword="ngModel" minlength="8" maxlength="15">

                        <small class="form-text text-danger"
                               *ngIf="(!NewPassword.valid && (NewPassword.dirty || NewPassword.touched)  && NewPassword.errors.minlength && !isRequesting)">(Mininum 8 Chars)</small>

                      </div>
                    </div>
                  </div>
                </div>
                <!--<div class="control">
                  <div class="label font-size-11px"></div>
                  <div class="input-group">
                    <label class="col-12">
                      <input type="password" class="form-control  border-bottom-tbl"
                             name="CurrentChangePasswordRequest.NewPassword"
                             id="CurrentChangePasswordRequest.NewPassword" pattern="^[\sa-zA-Z0-9,._\-?,$@!%*?&]*$"
                             placeholder="Enter NewPassword" [(ngModel)]="CurrentChangePasswordRequest.NewPassword" required #NewPassword="ngModel" minlength="8" maxlength="15">

                      <small class="form-text text-danger"
                             *ngIf="(!NewPassword.valid && (NewPassword.dirty || NewPassword.touched)  && NewPassword.errors.minlength && !isRequesting)">(Mininum 8 Chars)</small>

                    </label>
                  </div>
                </div>-->
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 padding-right-5px">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Re-Enter Password</label>
                      </div>

                      <div class="col-md-6">
                        <input type="password" class="form-control  border-bottom-tbl"
                               name="CurrentChangePasswordRequest.ReEnterPassword"
                               id="CurrentChangePasswordRequest.ReEnterPassword" pattern="^[\sa-zA-Z0-9,._\-?,$@!%*?&]*$"
                               placeholder="Re-Enter New Password" [(ngModel)]="CurrentChangePasswordRequest.ReEnterPassword" required #ReEnterPassword="ngModel" minlength="8" maxlength="15">

                        <small class="form-text text-danger"
                               *ngIf="(!ReEnterPassword.valid && (ReEnterPassword.dirty || ReEnterPassword.touched)  && ReEnterPassword.errors.minlength && !isRequesting)">(Mininum 8 Chars)</small>

                      </div>
                    </div>
                  </div>
                </div>
                <!--<div class="control">
                  <div class="label font-size-11px"></div>
                  <div class="input-group">
                    <label class="col-12">
                      <input type="password" class="form-control  border-bottom-tbl"
                             name="CurrentChangePasswordRequest.ReEnterPassword"
                             id="CurrentChangePasswordRequest.ReEnterPassword" pattern="^[\sa-zA-Z0-9,._\-?,$@!%*?&]*$"
                             placeholder="Re-Enter New Password" [(ngModel)]="CurrentChangePasswordRequest.ReEnterPassword" required #ReEnterPassword="ngModel" minlength="8" maxlength="15">

                      <small class="form-text text-danger"
                             *ngIf="(!ReEnterPassword.valid && (ReEnterPassword.dirty || ReEnterPassword.touched)  && ReEnterPassword.errors.minlength && !isRequesting)">(Mininum 8 Chars)</small>
                    </label>
                  </div>
                </div>-->
                <div class="control signin-control">
                  <!--<a (click)="onLogin()" class="nav-link-hand">Back</a>-->
                </div>


              </div>


            </div>

            <div class="card-footer text-align-center">

              <button type="button"  [disabled]="!f.valid" class="btn btn-primary font-size-13px nav-link-hand" (click)="onChangePassword()" *ngIf='!isRequesting'>Change Password</button>
            </div>



          </div>
        </form>
      </div>
    </div>
  </div>
</div>


